import React, { Component } from 'react';

import { Answer } from 'kb-shared';
import { FormText as Text } from 'screens/IntakeForm/components/Primitives/FormText';
import styled from 'styled-components';

import AnimatedWrapper from '../AnimatedWrapper';
import FormButton from '../FormButton';
import TextAreaInput from '../Primitives/TextAreaInput';

type Props = {
  title: string;
  onContinue?: () => void;
  onSave: (response: string) => void;
  answer: Answer | null;
  isRequired: boolean | null;
};
type State = {
  response: string;
};

export default class TextForm extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      response: (props.answer && props.answer.data) || ''
    };
  }

  renderContinueButton() {
    if (!this.props.onContinue) return null;

    const hidden = this.state.response ? false : true;
    return (
      <AnimatedWrapper isHidden={hidden}>
        <FormButton
          text={'Continue'}
          onClick={() => this.props.onContinue && this.props.onContinue()}
        />
      </AnimatedWrapper>
    );
  }

  render() {
    return (
      <Container>
        <Text isRequired={this.props.isRequired}>{this.props.title}</Text>
        <TextAreaInput
          value={this.state.response}
          placeholder={'Type your answer here...'}
          onChange={e => {
            const response = e.target.value;
            this.setState(() => ({
              response: response
            }));
          }}
          onBlur={e => this.props.onSave(e.target.value)}
        />
        {this.renderContinueButton()}
      </Container>
    );
  }
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;
